export const memberList = [{
  id: '10001',
  name: 'Frank',
  lastName: '陳',
  firstName: '小明',
  email: 'frank@micfo.com',
  account: 'frank@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '尚未',
  realAuth: true,
},
{
  id: '10002',
  name: 'John',
  lastName: '陳',
  firstName: '小明',
  email: 'John@micfo.com',
  account: 'John@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: true,
  baseAuth: '完成',
  realAuth: true,
},
{
  id: '10003',
  name: 'Amy',
  lastName: '陳',
  firstName: '小明',
  email: 'Amy@micfo.com',
  account: 'Amy@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '女',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '完成',
  realAuth: false,
},
{
  id: '10004',
  name: 'Daniel',
  lastName: '陳',
  firstName: '小明',
  email: 'Daniel@micfo.com',
  account: 'Daniel@micfo.com',
  city: '新北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '尚未',
  realAuth: false,
},
{
  id: '10005',
  name: 'Jack',
  lastName: '陳',
  firstName: '小明',
  email: 'Jack@micfo.com',
  account: 'Jack@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '尚未',
  realAuth: false,
},
{
  id: '10006',
  name: 'Frank',
  lastName: '陳',
  firstName: '小明',
  email: 'frank@micfo.com',
  account: 'frank@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '尚未',
  realAuth: false,
},
{
  id: '10007',
  name: 'Frank',
  lastName: '陳',
  firstName: '小明',
  email: 'frank@micfo.com',
  account: 'frank@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '尚未',
  realAuth: false,
},
{
  id: '10008',
  name: 'Frank',
  lastName: '陳',
  firstName: '小明',
  email: 'frank@micfo.com',
  account: 'frank@micfo.com',
  city: '台北市',
  district: '大同區',
  gender: '男',
  address: '忠孝東路一段1號',
  img1: '',
  img2: '',
  avatar: '',
  mobile: '0912345678',
  status: '啟用',
  blackList: false,
  baseAuth: '尚未',
  realAuth: false,
},
];

export const typeManagementList = [
  {
    id: 1,
    name: 'test1',
  },
  {
    id: 2,
    name: 'test2',
  },
  {
    id: 3,
    name: 'test3',
  },
  {
    id: 4,
    name: 'test4',
  },
  {
    id: 5,
    name: 'test5',
  },
  {
    id: 6,
    name: 'test6',
  },
  {
    id: 7,
    name: 'test7',
  },
  {
    id: 8,
    name: 'test8',
  },
];

export const pointList = [
  {
    id: 1,
    type: '紅利點數',
    name: '亞洲萬里通',
    exchangeRate: '2.85',
  },
  {
    id: 2,
    type: '超商點數',
    name: '全家',
    exchangeRate: '2.20',
  },
];

export const transactionLogList = [
  {
    id: '10397',
    name: '王大明',
    type: '個人',
    transactionType: '好友轉賬',
    point: 1000,
    transactionId: '12903',
    exchangeRate: 2.85,
    good: '',
    number: '',
    isGet: '是',
    endDate: '2021/06/20',
    transactionDate: '2020/05/30',
    comment: '全家手工',
  },
];

export const mediaList = [
  {
    id: 1,
    name: '聯合報',
    logo: '',
  },
  {
    id: 2,
    name: '自由電子報',
    logo: '',
  },
];

export const newsList = [
  {
    id: '1',
    image: 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',
    date: '2020/05/20',
    title: 'Top western road trips',
    media: '1,000 miles of wonder',
    content: 'Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands',
    link: 'google.com',
  },
  {
    id: '2',
    image: 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',
    date: '2020/05/20',
    title: 'Top western road trips',
    media: '1,000 miles of wonder',
    content: 'Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands',
    link: 'google.com',
  },
  {
    id: '3',
    image: 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',
    date: '2020/05/20',
    title: 'Top western road trips',
    media: '1,000 miles of wonder',
    content: 'Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands',
    link: 'google.com',
  },
  {
    id: '4',
    image: 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',
    date: '2020/05/20',
    title: 'Top western road trips',
    media: '1,000 miles of wonder',
    content: 'Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands',
    link: 'google.com',
  },
  {
    id: '5',
    image: 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg',
    date: '2020/05/20',
    title: 'Top western road trips',
    media: '1,000 miles of wonder',
    content: 'Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands,Whitehaven Beach, Whitsunday Island, Whitsunday Islands',
    link: 'google.com',
  },
];

export default {
  memberList,
  pointList,
  typeManagementList,
  transactionLogList,
  mediaList,
  newsList,
};
